import React, { useState } from "react";
import { BiEdit, BiTrash } from "react-icons/bi";
import { WrittenFormat } from "../WrittenFormat";
import { formatText } from "../TruncateParties";
import DeleteConfirmationModal from "../DeleteConfirmationModal/DeleteConfirmationModal";

export const RenderExpenses = ({ 
  expensesData, 
  setModalTab, 
  setShowModal, 
  onEditExpense, 
  onDeleteExpense 
}) => {
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, expenseId: null, expenseType: '' });
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const expenses = expensesData?.expenses || [];

  // Helper function to truncate text by word count
  const truncateText = (text, wordLimit = 40) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ");
  };

  // Helper function to get word count
  const getWordCount = (text) => {
    if (!text) return 0;
    return text.split(/\s+/).filter(word => word.length > 0).length;
  };

  // Toggle description expansion
  const toggleDescription = (expenseId, e) => {
    e.stopPropagation();
    setExpandedDescriptions(prev => ({
      ...prev,
      [expenseId]: !prev[expenseId]
    }));
  };

  const handleDeleteClick = (expenseId, expenseType) => {
    setDeleteModal({ isOpen: true, expenseId, expenseType });
  };

  const handleConfirmDelete = async () => {
    await onDeleteExpense(deleteModal.expenseId);
    setDeleteModal({ isOpen: false, expenseId: null, expenseType: '' });
  };

  const handleCancelDelete = () => {
    setDeleteModal({ isOpen: false, expenseId: null, expenseType: '' });
  };

  return (
    <div className="tab-content">
      <div className="summary">
        <div className="sum-amount">
          <p className="margin-zero">
            <strong>Total Amount:</strong> ₹{expensesData?.totalAmount}
          </p>
          <p className="margin-zero exp-count">
            <strong>Total Expenses Count:</strong> {expensesData?.expenseCount}
          </p>
        </div>
        <div className="tab-add">
          <button
            onClick={() => {
              setModalTab("Expenses");
              setShowModal(true);
              onEditExpense(null);
            }}
          >
            Add Expense
          </button>
        </div>
      </div>

      {console.log(expenses, "expenses")}
      {expenses.length === 0 ? (
        <div className="no-data-container">
          <h3 className="no-data-title">No Expenses Found</h3>
          <p className="no-data-message">
            No expenses have been recorded for this case yet. Click "Add Expense" to track your first expense.
          </p>
        </div>
      ) : (
        expenses.map((expense, index) => (
          <div key={index} className="order-card">
            <div className="order-expense-card">
              <div>
                <p>
                  <strong>Type :</strong> {WrittenFormat(expense.type)}
                </p>
                <p style={{ 
                  paddingRight: "20px",
                  wordBreak: "break-word",
                  maxWidth: "100%"
                }}>
                  <strong>Description :</strong>{" "}
                  {expandedDescriptions[expense._id]
                    ? expense.description
                    : getWordCount(expense.description) > 40
                    ? (
                      <>
                        {truncateText(expense.description, 40)}...{" "}
                        <button
                          onClick={(e) => toggleDescription(expense._id, e)}
                          style={{
                            padding: "2px 8px",
                            fontSize: "12px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: "#f5f5f5",
                            cursor: "pointer",
                            color: "#333",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Show More
                        </button>
                      </>
                    )
                    : expense.description}
                  {expandedDescriptions[expense._id] && getWordCount(expense.description) > 40 && (
                    <>
                      {" "}
                      <button
                        onClick={(e) => toggleDescription(expense._id, e)}
                        style={{
                          padding: "2px 8px",
                          fontSize: "12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#f5f5f5",
                          cursor: "pointer",
                          color: "#333",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Show Less
                      </button>
                    </>
                  )}
                </p>
                <p>
                  <strong>Court Ref :</strong> {expense.courtRef}
                </p>
                <p>
                  <strong>Resource Name :</strong> {expense.resourceName}
                </p>
              </div>
              <div>
                <p>
                  <strong>Date :</strong>{" "}
                  {new Date(expense.date).toLocaleDateString()}
                </p>
                <p>
                  <strong>Amount :</strong> ₹{expense.amount}
                </p>
                <p>
                  <strong>Type of Resource :</strong> {formatText(expense.typeOfResource)}
                </p>
                {expense.documentUrl && (
                  <p>
                    <strong>Document :</strong>{" "}
                    <a
                      href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${expense.documentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Document
                    </a>
                  </p>
                )}
              </div>
            </div>
            <div className="editdel">
              <button
                onClick={() => {
                  setModalTab("Expenses");
                  setShowModal(true);
                  onEditExpense(expense);
                }}
                className="editbtn"
              >
                <BiEdit size={16} />
              </button>
              <button 
                onClick={() => handleDeleteClick(expense._id, expense.type)} 
                className="delbtn"
              >
                <BiTrash size={16} />
              </button>
            </div>
          </div>
        ))
      )}

      <DeleteConfirmationModal
        isOpen={deleteModal.isOpen}
        itemType={`this expense "${WrittenFormat(deleteModal.expenseType)}"`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </div>
  );
};